import { Container } from "../../Atoms/Container";
import { GoalsFormTemplate } from "../../Templates/GoalsFormTemplate";
import * as S from "./styles";
import { useGoalsRegister } from "./useGoalsRegister";

export const GoalsRegister = () => {
  const { handleSubmit } = useGoalsRegister();

  return (
    <Container>
      <S.Wrapper>
        <h1>Cadastrar Meta</h1>
        <GoalsFormTemplate handleSubmit={handleSubmit} />
      </S.Wrapper>
    </Container>
  );
};
